export default __webpack_public_path__ + "static/media/yocket.9b45709e.jpeg";